
export enum LocationSearchMethod {
    LOCATION_PARTNER = "LOCATION_PARTNER",
    ZONE = "ZONE",
    CATEGORY= "CATEGORY"
}